import { filterBySearchPhrase } from 'shared/utils/filterBySearchPhrase';
import { userModelToUserModelLabelled } from 'shared/domain/user/mapping/toView';
import type { LabelledUserModel, UserModel } from 'shared/domain/user/types/model';

/** What the users table search looks in (the label depends on the organization). */
const PROJECT_USER_SEARCHABLE_FIELDS = ['label', 'email'] as const;

/** The users matching the phrase, labelled as in the organization; all of them without a phrase. */
export function findProjectUsersMatchingPhrase(
  users: UserModel[],
  phrase: string,
  organizationId: string
): LabelledUserModel[] {
  return filterBySearchPhrase(
    users.map((user) => userModelToUserModelLabelled(user, organizationId)),
    phrase,
    PROJECT_USER_SEARCHABLE_FIELDS
  );
}
